import { Route, Routes } from 'react-router-dom'
import { CreatePage } from 'pages/clients/pages/create'
import { CreateLayout } from 'pages/clients/pages/create/layout/CreateLayout'

export const CreateRouter = () => {
  return (
    <Routes>
      <Route element={<CreateLayout />}>
        <Route path={'/'} element={<CreatePage />} />
      </Route>
    </Routes>
  )
}
